import { AppService } from './app.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../environments/environment';
var PreLoginComponent = /** @class */ (function () {
    function PreLoginComponent(_service, _router, router, spinnerService) {
        this._service = _service;
        this._router = _router;
        this.router = router;
        this.spinnerService = spinnerService;
        this.preloginData = { "phone": "", "pin": "", "recaptchaResponse": "" };
        this.ACTION = 'login'; // modifica se vuoi: 'signup', 'submit_form', ecc.
        this.captchaRetries = 0;
        this.maxRetries = 50; // 10 secondi (50 * 200ms)
        this.typeSelected = 'ball-fussion';
        this.captcha_key = environment.captcha_key;
    }
    PreLoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.preloginData.phone = this._router.snapshot.params['username'];
        this.preloginData.pin = this._router.snapshot.params['password'];
        // Sottoscrizione per rigenerare il captcha quando c'è un errore
        this._service.regenerateCaptcha$.subscribe(function () {
            _this.regenerateCaptcha();
        });
        // Aspetta che il DOM sia completamente caricato
        if (document.readyState === 'complete') {
            this.requestRecaptchaV3Token();
        }
        else {
            window.addEventListener('load', function () {
                setTimeout(function () { return _this.requestRecaptchaV3Token(); }, 500);
            });
        }
    };
    PreLoginComponent.prototype.requestRecaptchaV3Token = function () {
        var _this = this;
        // Verifica se window.grecaptcha esiste
        var globalgrecaptcha = window.grecaptcha;
        if (typeof globalgrecaptcha === 'undefined' || !globalgrecaptcha || !globalgrecaptcha.enterprise) {
            this.captchaRetries++;
            if (this.captchaRetries >= this.maxRetries) {
                console.error('reCAPTCHA script failed to load after ' + this.maxRetries + ' retries');
                // Imposta un token vuoto per permettere comunque il login
                // il backend gestirà la validazione
                this.preloginData.recaptchaResponse = 'captcha-load-failed';
                return;
            }
            console.log('grecaptcha not loaded yet, retrying... (' + this.captchaRetries + '/' + this.maxRetries + ')');
            setTimeout(function () { return _this.requestRecaptchaV3Token(); }, 200);
            return;
        }
        try {
            globalgrecaptcha.enterprise.ready(function () {
                globalgrecaptcha.enterprise.execute(environment.captcha_key, { action: _this.ACTION })
                    .then(function (token) {
                    _this.preloginData.recaptchaResponse = token;
                    console.log('reCAPTCHA v3 token:', token);
                })
                    .catch(function (error) {
                    console.error('reCAPTCHA execute error:', error);
                    _this.preloginData.recaptchaResponse = 'captcha-execute-failed';
                });
            });
        }
        catch (error) {
            console.error('reCAPTCHA ready error:', error);
            this.preloginData.recaptchaResponse = 'captcha-ready-failed';
        }
    };
    PreLoginComponent.prototype.regenerateCaptcha = function () {
        // Reset dei retry e rigenera il token
        this.captchaRetries = 0;
        console.log('Regenerating captcha token...');
        this.requestRecaptchaV3Token();
    };
    PreLoginComponent.prototype.handleCorrectCaptcha = function (captchaRes) {
        console.log("Resolved response token: " + captchaRes);
        this.preloginData.recaptchaResponse = captchaRes;
        //this.preloginData.recaptchaResponse = this.captcha.getResponse();
        console.log(this.preloginData);
        // this.captcha.reset();
        this._service.preLogin(this.preloginData);
    };
    PreLoginComponent.prototype.showSpinner = function () {
        this.spinnerService.show();
        // setTimeout(() => {
        //  this.spinnerService.hide();
        // }, 5000); // 5 seconds
    };
    PreLoginComponent.prototype.register = function () {
        this.router.navigate(['/register']);
    };
    PreLoginComponent.prototype.preLogin = function () {
        this.showSpinner();
        if (this.preloginData.phone.indexOf('+') != -1) {
            this.preloginData.phone = this.preloginData.phone.substring(1);
        }
        if (this.preloginData.phone.substring(0, 2) == "00") {
            this.preloginData.phone = this.preloginData.phone.substring(2);
        }
        console.log(this.preloginData);
        this._service.preLogin(this.preloginData);
        // this.captcha.execute();
        //this.preloginData.recaptchaResponse = this.captcha.getResponse();
        //console.log(this.preloginData);
        //this._service.preLogin(this.preloginData);
    };
    return PreLoginComponent;
}());
export { PreLoginComponent };
